import './UnlinkConfirmationModal.scss';

import React, { Fragment } from 'react';
import noop from 'lodash/noop';
import { func } from 'prop-types';

import Content from 'services/Content';
import ActionButton from 'components/shared/Buttons/ActionButton';

export const UnlinkConfirmationModal = ({ onKeep, onUnlink }) => {
  return (
    <Fragment>
      <div className="unlink-confirmation-container" data-metrics-location="PU">
        <p className="unlink-confirmation-title">Are you Sure?</p>
        <p
          className="unlink-confirmation-copy"
          dangerouslySetInnerHTML={{
            __html: Content.rpsCardUnlinkConfirmationText
          }}
        />
        <div className="unlink-confirmation-cancel">
          <button
            data-metrics-location="PU_BTN"
            id="cancel-unlink-confirmation-btn"
            onClick={onKeep}>
            <span id="cancel-unlink-confirmation">Keep</span>
          </button>
          <ActionButton
            data-metrics-location="PU_BTN"
            id="unlink-confirmation"
            type="primary"
            onClick={onUnlink}>
            Unlink
          </ActionButton>
        </div>
      </div>
    </Fragment>
  );
};

UnlinkConfirmationModal.propTypes = {
  onKeep: func.required,
  onUnlink: func.required
};

UnlinkConfirmationModal.defaultProps = {
  onKeep: noop,
  onUnlink: noop
};

export default UnlinkConfirmationModal;
